import { create } from "zustand";
import { persist } from 'zustand/middleware';

const useStyleStore = create(
  persist((set) => ({
    sidebarOpen: true,
    setSidebarOpen: (open) => set({ sidebarOpen: open }),
  }),
  {
    name: 'alert-storage', // unique name
  })
);

export default useStyleStore;